import { BuilderComponentGroup } from '../types'

export const DashboardsDesignBlocks: BuilderComponentGroup = {
  id: 'dashboards',
  title: 'Dashboards',
  components: [
    {
      compId: 'dashboard1',
      title: 'Dashboard 1',
      icon: 'Dashboard1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'dashboard2',
      title: 'Dashboard 2',
      icon: 'Dashboard2',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
  ],
}
